// SAL3050_R01 전용 DTO (공통 Dto 없으므로 직접 정의)

import { DateRange } from 'react-day-picker';

// 검색 조건
export interface SAL3050_R01Filter {
    compCd: string;
    dateRange: DateRange | undefined;
    areaCd: string;       // 영업지역
    customCd: string;
    customNm: string;
}

// 상단 헤더 DTO
export interface SAL3050_R01HeaderDto {
    customCd: string;
    customNm: string;
    baseAmt: number;      // 기초잔액
    purAmt: number;       // 매입액
    salAmt: number;       // 매출액
    collectAmt: number;   // 수금액
    payAmt: number;       // 지불액
    balance: number;      // 잔액
    remark: string;

    // AG Grid용
    inserted?: boolean;
    isModified?: boolean;
}

export const defaultSAL3050_R01HeaderDto: SAL3050_R01HeaderDto = {
    customCd: '',
    customNm: '',
    baseAmt: 0,
    purAmt: 0,
    salAmt: 0,
    collectAmt: 0,
    payAmt: 0,
    balance: 0,
    remark: '',
    inserted: false,
    isModified: false,
};

// 하단 상세 DTO
export interface SAL3050_R01DetailDto {
    valueIndex: number;   // 그리드 key용
    txDate: string;
    txType: string;       // BASE / SAL / PUR / COL / PAY
    itemCd: string;
    itemNm: string;
    qty: number;
    unitPrice: number;
    discount: number;
    salPayAmt: number;    // 매출.지불액
    purColAmt: number;    // 매입.수금액
    balance: number;
    remark: string;

    // AG Grid용
    inserted?: boolean;
    isModified?: boolean;
}

export const defaultSAL3050_R01DetailDto: SAL3050_R01DetailDto = {
    valueIndex: 0,
    txDate: '',
    txType: '',
    itemCd: '',
    itemNm: '',
    qty: 0,
    unitPrice: 0,
    discount: 0,
    salPayAmt: 0,
    purColAmt: 0,
    balance: 0,
    remark: '',
    inserted: false,
    isModified: false,
};
